<template>
    <div class="goods">
        <Header ref="header" :title="title" @backPage="onBack" :titleRight="titleRight"></Header>
        <div class="outModel">
            <Category :ctIndex='ctIndex'></Category>
        </div>
    </div>
</template>
<script>
import Category from './common/category'
import Header from '../../common/header'
import { mapMutations, mapState } from 'vuex'
import { clearCache, newCache } from '@/utils/index'
export default {
    name: 'allGoods',
    components: {
        Header,
        Category
    },
    data () {
        return {
            title: '更多类目',
            ctIndex: 0,
            titleRight: ''
        }
    },
    watch: {
        '$route' (to, from) {
            if (to.name === 'allGoods') { // 跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
                let recruitScrollY = this.getScroll
                this.$nextTick(() => {
                    window.scroll(0, recruitScrollY)
                })
            }
        }
    },
    computed: {
        ...mapState({
            getScroll: state => state.recruitScrollY
        })
    },
    beforeRouteEnter (to, from, next) {
        newCache('allGoods')
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (to.name !== 'goodsList') {
            clearCache('allGoods')
        }
        let position = window.scrollY
        if (position == null) position = 0
        this.setSCROLL(position)
        next()
    },
    methods: {
        ...mapMutations({
            setSCROLL: 'SCROLL_Y'
        }),
        onBack () {
            this.$router.push({ path: '/b2b/home/index', query: { tab: this.$route.query.tab } })
        }
    },
    mounted () {
        this.ctIndex = this.$route.query.ctIndex
    }
}
</script>
<style lang="scss" scoped>
    .outModel{
        height: calc(100% - 120px);
        overflow: auto;
    }
    .goods{
        height: 100%;
        font-size: 28px;
        overflow: hidden;
        .nav{
            width: 100%;
            height: 88px;
            line-height: 88px;
            background: #ffffff;
            color: #666666;
            border-bottom: 2px solid #D1D1D6;
            overflow: hidden;
            position: fixed;
            box-sizing: border-box;
            .navUl{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                z-index: 9;
                height: 100%;
                .navLi{
                    // width: 150px;
                    text-align: center;
                    position: relative;
                    display: table-cell;
                    vertical-align: middle;
                    margin-left: 30px;
                    float: left;
                    span{
                        padding: 8px 30px;
                        &.active{
                            color: #ffffff;
                            background: #FF7A45;
                            // width: 76px;
                            text-align: center;
                            line-height: 40px;
                            border-radius: 56px;
                        }
                    }
                }
            }
        }
    }
</style>